// components/LevelSelector.jsx
import React from 'react';

const LevelSelector = ({ levels, currentLevel, onLevelChange }) => {
  return (
    <div className="level-selector">
      <div className="d-flex align-items-center gap-2 mb-2">
        <small className="text-muted">Level:</small>
        <div className="btn-group btn-group-sm" role="group">
          {levels.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`btn ${currentLevel === index ? 'btn-primary' : 'btn-outline-primary'} level-btn`}
              onClick={() => onLevelChange(index)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LevelSelector;